import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  WorkOSActionTypes,
  WorkOSCreated,
  WorkOSOnServerCreated,
  WorkOSOnServerUpdated,
  WorkOSsActionToggleLoading,
  WorkOSsPageCancelled,
  WorkOSsPageLoaded,
  WorkOSsPageRequested,
  WorkOSsPageToggleLoading,
  WorkOSUpdated,
  FireWorkOSSuccess,
  ThrowWorkOSError,
} from '../_actions/workOS.actions';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';
import { WorkOSService } from '../_services/workOS.service';

@Injectable()
export class WorkOSEffects {
  showPageLoadingDistpatcher = new WorkOSsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new WorkOSsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new WorkOSsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new WorkOSsActionToggleLoading({ isLoading: false });

  @Effect()
  loadWorkOSsPage$ = this.actions$.pipe(
    ofType<WorkOSsPageRequested>(WorkOSActionTypes.WorkOSsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.workOS.findWorkOSs(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              this.authService.logout();
              return new WorkOSsPageCancelled();
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new WorkOSsPageCancelled();
            } else {
              this.store.dispatch(new ThrowWorkOSError({ error: response[0].error }));
              return new WorkOSsPageCancelled();
            }
          } else {
            const result = response[0];
            return new WorkOSsPageLoaded({
              workOSs: result.data,
              totalCount: result.count,
              page: response[1],
            });
          }
        }),
      );
    }),
  );

  @Effect()
  updateWorkOS$ = this.actions$.pipe(
    ofType<WorkOSOnServerUpdated>(WorkOSActionTypes.WorkOSOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.workOS.updateWorkOS(payload.workOS).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res.error) {
            return new ThrowWorkOSError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              new FireWorkOSSuccess({ action_type: WorkOSActionTypes.WorkOSUpdated }),
            );
            return new WorkOSUpdated(payload);
          }
        }),
      );
    }),
  );

  @Effect()
  createWorkOS$ = this.actions$.pipe(
    ofType<WorkOSOnServerCreated>(WorkOSActionTypes.WorkOSOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.workOS.createWorkOS(payload.workOS).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res.status === 201) {
            this.store.dispatch(
              new FireWorkOSSuccess({ action_type: WorkOSActionTypes.WorkOSCreated }),
            );
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            return new WorkOSCreated({ workOS: res.body.data });
          } else {
            return new ThrowWorkOSError({ error: res });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private workOS: WorkOSService,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
